import { render } from "./DueDateManagement.vue?vue&type=template&id=27f647b9&scoped=true&ts=true"
import script from "./DueDateManagement.vue?vue&type=script&lang=ts"
export * from "./DueDateManagement.vue?vue&type=script&lang=ts"

import "./DueDateManagement.vue?vue&type=style&index=0&id=27f647b9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27f647b9"]])

export default __exports__